export async function downloadDocuments<T>(
	data: T,
	fileName: string,
	apiCall: (arg0: T) => any,
) {
	const result = await apiCall(data);
	const file = new Blob([result as unknown as BlobPart]);
	const fileURL = URL.createObjectURL(file);
	const link = document.createElement('a');
	link.download = fileName;
	link.href = fileURL;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}
